import React from "react";

type ContextType = {
  open: boolean,
  unit: any,
  documentTypes: any[],
  unitType: any,
  refresh: any,
  documentTypeId: any,
}
export default React.createContext<ContextType>({
  open: false,
  unit: null,
  documentTypes: [],
  unitType: null,
  refresh: null,
  documentTypeId: null
})